'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _angularFix = require('angular-fix');

var _angularFix2 = _interopRequireDefault(_angularFix);

exports['default'] = formlyForm;

/**
 * @ngdoc directive
 * @name formlyForm
 * @restrict AE
 */
// @ngInject
function formlyForm(formlyUsability, formlyWarn, $parse, formlyConfig, $interpolate) {
  var currentFormId = 1;
  return {
    restrict: 'AE',
    template: formlyFormGetTemplate,
    replace: true,
    transclude: true,
    scope: {
      fields: '=',
      model: '=',
      form: '=?',
      options: '=?'
    },
    controller: 'FormlyFormController',
    link: formlyFormLink
  };

  function formlyFormGetTemplate(el, attrs) {
    var rootEl = getRootEl();
    var fieldRootEl = getFieldRootEl();
    var formId = 'formly_' + currentFormId++;
    var parentFormAttributes = '';
    if (attrs.hasOwnProperty('isFieldGroup') && el.parent().parent().hasClass('formly')) {
      parentFormAttributes = copyAttributes(el.parent().parent()[0].attributes);
    }
    return '\n        <' + rootEl + ' class="formly"\n                 name="' + getFormName() + '"\n                 role="form" ' + parentFormAttributes + '>\n          <' + fieldRootEl + ' formly-field\n               ng-repeat="field in fields ' + getTrackBy() + '"\n               ' + getHideDirective() + '="!field.hide"\n               class="formly-field"\n               options="field"\n               model="field.model || model"\n               original-model="model"\n               fields="fields"\n               form="theFormlyForm"\n               form-id="' + getFormName() + '"\n               form-state="options.formState"\n               form-options="options"\n               index="$index">\n          </' + fieldRootEl + '>\n          <div ng-transclude class="' + getTranscludeClass() + '"></div>\n        </' + rootEl + '>\n      ';

    function getRootEl() {
      return attrs.rootEl || 'ng-form';
    }

    function getFieldRootEl() {
      return attrs.fieldRootEl || 'div';
    }

    function getHideDirective() {
      return attrs.hideDirective || formlyConfig.extras.defaultHideDirective || 'ng-if';
    }

    function getTrackBy() {
      if (!attrs.trackBy) {
        return '';
      } else {
        return 'track by ' + attrs.trackBy;
      }
    }

    function getFormName() {
      var formName = formId;
      var bindName = attrs.bindName;
      if (bindName) {
        if (_angularFix2['default'].version.minor < 3) {
          throw formlyUsability.getFormlyError('bind-name attribute on formly-form not allowed in < angular 1.3');
        }
        // we can do a one-time binding here because we know we're in 1.3.x territory
        formName = $interpolate.startSymbol() + '::\'formly_\' + ' + bindName + $interpolate.endSymbol();
      }
      return formName;
    }

    function getTranscludeClass() {
      return attrs.transcludeClass || '';
    }

    function copyAttributes(attributes) {
      var excluded = ['model', 'form', 'fields', 'options', 'name', 'role', 'class', 'data-model', 'data-form', 'data-fields', 'data-options', 'data-name'];
      var arrayAttrs = [];
      _angularFix2['default'].forEach(attributes, function (_ref) {
        var nodeName = _ref.nodeName;
        var value = _ref.value;

        if (nodeName !== 'undefined' && excluded.indexOf(nodeName) === -1) {
          arrayAttrs.push(toKebabCase(nodeName) + '="' + value + '"');
        }
      });
      return arrayAttrs.join(' ');
    }
  }

  function formlyFormLink(scope, el, attrs) {
    setFormController();
    fixChromeAutocomplete();

    function setFormController() {
      var formId = attrs.name;
      scope.formId = formId;
      scope.theFormlyForm = scope[formId];
      if (attrs.form) {
        var getter = $parse(attrs.form);
        var setter = getter.assign;
        var parentForm = getter(scope.$parent);
        if (parentForm) {
          scope.theFormlyForm = parentForm;
          if (scope[formId]) {
            scope.theFormlyForm.$removeControl(scope[formId]);
          }

          // this next line is probably one of the more dangerous things that angular-formly does to improve the
          // API for angular-formly forms. It ensures that the NgModelControllers inside of formly-form will be
          // attached to the form that is passed to formly-form rather than the one that formly-form creates
          // this is necessary because it's confusing to have a step between the form you pass in
          // and the fields in that form. It also is because angular doesn't propagate properties like $submitted down
          // to children forms :-( This line was added to solve this issue:
          // https://github.com/formly-js/angular-formly/issues/287
          // luckily, this is how the formController has been accessed by the NgModelController since angular 1.0.0
          // so I expect it will remain this way for the life of angular 1.x
          el.removeData('$formController');
        } else {
          setter(scope.$parent, scope[formId]);
        }
      }
      if (!scope.theFormlyForm && !formlyConfig.disableWarnings) {
        /* eslint no-console:0 */
        formlyWarn('formly-form-has-no-formcontroller', 'Your formly-form does not have a `form` property. Many functions of the form (like validation) may not work', el, scope);
      }
    }

    /*
     * chrome autocomplete lameness
     * see https://code.google.com/p/chromium/issues/detail?id=468153#c14
     * ლ(ಠ益ಠლ)   (╯°□°)╯︵ ┻━┻    (◞‸◟；)
     */
    function fixChromeAutocomplete() {
      var global = formlyConfig.extras.removeChromeAutoComplete === true;
      var offInstance = scope.options && scope.options.removeChromeAutoComplete === false;
      var onInstance = scope.options && scope.options.removeChromeAutoComplete === true;
      if (global && !offInstance || onInstance) {
        var input = document.createElement('input');
        input.setAttribute('autocomplete', 'address-level4');
        input.setAttribute('hidden', 'true');
        el[0].appendChild(input);
      }
    }
  }

  // stateless util functions
  function toKebabCase(string) {
    if (string) {
      return string.replace(/([A-Z])/g, function ($1) {
        return '-' + $1.toLowerCase();
      });
    } else {
      return '';
    }
  }
}
module.exports = exports['default'];


/** WEBPACK FOOTER **
 ** ./directives/formly-form.js
 **/